module.exports = __webpack_public_path__ + "static/media/TxHorizontal.49f1ca17.png";